import React from 'react';
import useTrack from '../../hooks/useTrack/useTrack';
import VideoTrack from '../VideoTrack/VideoTrack';
import type { AgoraPublicationLike, AgoraParticipantLike, IVideoTrack } from '../../types';

interface PublicationProps {
  publication: AgoraPublicationLike;
  participant: AgoraParticipantLike;
  isLocalParticipant?: boolean;
  videoOnly?: boolean;
  videoPriority?: unknown;
}

export default function Publication({ publication, isLocalParticipant, videoPriority }: PublicationProps) {
  const track = useTrack(publication);

  if (!track) return null;

  const kind = (track as any).trackMediaType ?? (track as any).kind;
  const trackName = (track as any).trackName ?? (track as any).name ?? '';

  if (kind === 'video') {
    return (
      <VideoTrack
        track={track as IVideoTrack}
        priority={videoPriority}
        isLocal={!trackName.includes('screen') && !!isLocalParticipant}
      />
    );
  }
  return null;
}
